import {Injectable} from '@angular/core';
import {Question} from '@shared/models/question';
import {Post} from '@shared/models/post';
import {Activity, ActivityType} from '@shared/models/activity';
import {Match} from '@shared/models/match';
import {BaseImage} from '@shared/models/image';
import {Picture} from '@core/services/picture';
import {TeamService} from '@core/services/team.service';
import {MatchService} from '@core/services/match.service';
import {TimeLinePhases} from '@shared/models/TimeLinePhase';
import {HttpClient} from '@angular/common/http';
import {APIService} from '@core/services/api.service';
import {MatchDetailViewMatch} from '@modules/game-detail/models/match-detail-view-match';
import {ISponsor} from '@api/models/sponsor/sponsor';
import { IEventStatusResponse } from '@api/models/event/event-status-response';
import { IMatchTickerItem } from '@lib-modules/match/models/match-ticker-item';

@Injectable()
export class MatchDetailViewService {

  public showTabs = {
    lineup: false,
    liveticker: false,
    overview: false,
    table: false,
    timeline: false,
    videos: false
  };
  data: MatchDetailViewMatch = null;
  public sponsors: ISponsor[];

  constructor( private matchService: MatchService,
               private teamService: TeamService,
               private http: HttpClient,
               private apiService: APIService ) { }

  public async updateTabs(): Promise<void> {
    this.showTabs = await this.getTabsToDisplay();
  }

  private resolveActivity(entry: any): Activity {
    const a = new Activity(entry);
    if (entry.pictures != null) {
      for (let i = 0; i < entry.pictures.length; i++) {
        const img = new BaseImage(entry.pictures[i]);
        a.images.push(img);
        const pic = new Picture(entry.pictures[i]);
        if (img.subtype === "face") {
          a.playerImage.push(pic);
        } else {
          a.otherImages.push(pic);
        }
      }
    }
    return a;
  }

  private resolvePost(entry: any): Post {
    const p = new Post(entry);
    if (entry.pictures != null) {
      for (let i = 0; i < entry.pictures.length; i++) {
        const img = new BaseImage(entry.pictures[i]);
        p.images.push(img);
        const pic = new Picture(entry.pictures[i]);
        if (img.subtype === "face") {
          p.playerImage.push(pic);
        } else {
          p.otherImages.push(pic);
        }
      }
    }
    return p;
  }

  public setupMatch() {
    this.data = new MatchDetailViewMatch();
  }

  public setSponsors(teamId: string): void {
    const teams = this.data.match.teams;
    const sponsors = teamId === teams.home.teamid ? teams.home.sponsors : teams.away.sponsors;
    this.sponsors = sponsors ?? [];
  }

  public async updateStatus(data: IEventStatusResponse): Promise<void> {
    this.data.minuteAndStatus = data.ui_minute;
    this.setScores(data.teams.home?.score, data.teams.away?.score);
    if (this.data.match.status !== data.status) {
      this.reloadMatch();
    }
  }
  public setScores(homeScore: number, awayScore: number): void {
    this.data.scores.home =
      homeScore !== null && homeScore !== -1 ? homeScore.toString() : '-';
    this.data.scores.away =
      awayScore !== null && awayScore !== -1 ? awayScore.toString() : '-';
  }

  // public onSocketQuestion(data: any): void {
  //   if (data.action === 'NEW') {
  //     const newQuestion = new Question(data);
  //     if (this.data.entries.find(value => value._id === newQuestion._id) == null) {
  //       this.data.entries.push(newQuestion);
  //     }
  //   }
  //   this.sortEntries();
  // }

  // public onSocketComment(message: any): void {
  //   if (message.action === 'NEW') {
  //     const newPost = this.resolvePost(message);
  //     if (this.data.entries.find(value => value._id === newPost._id) == null) {
  //       this.data.entries.push(newPost);
  //     }
  //   } else if (message.action === 'DELETE') {
  //     const index = this.data.entries.findIndex(value => value._id === message._id);
  //     if (index !== -1) {
  //       this.data.entries.splice(index, 1);
  //     }
  //   } else if (message.action === 'UPDATE') {
  //     const index = this.data.entries.findIndex(value => value._id === message._id);
  //     if (index !== -1) {
  //       const updatedPost = this.resolvePost(message);
  //       if (updatedPost.text != null) {
  //         this.data.entries[index].text = updatedPost.text;
  //       }
  //       if (updatedPost.activation_milliseconds != null) {
  //         this.data.entries[index].activation_milliseconds = updatedPost.activation_milliseconds;
  //       }
  //       if (updatedPost.activation_relative_to != null) {
  //         this.data.entries[index].activation_relative_to = updatedPost.activation_relative_to;
  //       }
  //       if (updatedPost.display_minute != null) {
  //         this.data.entries[index].display_minute = updatedPost.display_minute;
  //       }
  //       if (message.pictures != null) {
  //         (this.data.entries[index] as Post).images = updatedPost.images;
  //         (this.data.entries[index] as Post).playerImage = updatedPost.playerImage;
  //         (this.data.entries[index] as Post).otherImages = updatedPost.otherImages;
  //       }
  //     }
  //   }
  //   this.sortEntries();
  // }

  // public onSocketActivity(message: any): void {
  //   if (message.action === 'NEW') {
  //     const newActivity = this.resolveActivity(message);
  //     if (this.data.entries.find(value => value._id === newActivity._id) == null) {
  //       this.data.entries.push(newActivity);
  //     }
  //   } else if (message.action === 'DELETE') {
  //     const index = this.data.entries.findIndex(value => value._id === message._id);
  //     if (index !== -1) {
  //       this.data.entries.splice(index, 1);
  //     }
  //   } else if (message.action === 'UPDATE') {
  //     const index = this.data.entries.findIndex(value => value._id === message._id);
  //     if (index !== -1) {
  //       const updatedActivity = this.resolveActivity(message);
  //       if (updatedActivity.text != null) {
  //         this.data.entries[index].text = updatedActivity.text;
  //       }
  //       if (message.pictures != null) {
  //         (this.data.entries[index] as Activity).images = updatedActivity.images;
  //         (this.data.entries[index] as Activity).playerImage = updatedActivity.playerImage;
  //         (this.data.entries[index] as Activity).otherImages = updatedActivity.otherImages;
  //       }
  //     }
  //   }
  //   this.sortEntries();
  // }

  public loadMatchDetails(match: Match, teamID: string): void {
    try {
      this.loadTimeline(match.id, teamID);
      this.loadTeamLineups(match);
    } catch (e) {
      console.error("[Match] Could not load match data!");
      throw e;
    }
  }

  public reloadMatchDetails(): void {
    this.loadMatchDetails(this.data.match, this.data.currentTeamId);
  }

  public reloadTimeline(): void {
    this.loadTimeline(this.data.match.id, this.data.currentTeamId);
  }

  public updateTimeline(items: IMatchTickerItem[]): void {
    const updatedEntries = [];
    items.forEach(entry => {
      if (entry.category === 'activity') {
        updatedEntries.push(this.resolveActivity(entry));
      } else if (entry.category === 'post') {
        updatedEntries.push(this.resolvePost(entry));
      }
    });
    this.data.entries = updatedEntries;
    this.sortEntries();
  }

  filterEntries(entries) {
    // replace data with objects
    entries.forEach(entry => {
      if (entry.category === 'activity') {
        this.data.entries.push(this.resolveActivity(entry));
      } else if (entry.category === 'post') {
        this.data.entries.push(this.resolvePost(entry));
      }
    });

    this.sortEntries();
  }

  sortEntries() {
    this.data.entries = this.data.entries.sort((a, b) => {
      return this.sortTimeline(a, b);
    });
  }

  private sortTimeline(a: any, b: any): number {
    const idxA = TimeLinePhases.findIndex(
      (phase) => phase === a.activation_relative_to
    );
    const idxB = TimeLinePhases.findIndex(
      (phase) => phase === b.activation_relative_to
    );

    if (
      a.activation_milliseconds === b.activation_milliseconds &&
      a.activation === b.activation
    ) {
      if (a.type === ActivityType.THANK_YOU.value) {
        return 1;
      }
      if (b.type === ActivityType.THANK_YOU.value) {
        return -1;
      }
    }

    return (
      idxB - idxA ||
      b.activation_milliseconds - a.activation_milliseconds ||
      b._created - a._created
    );
  }

  public getMinuteString(): string {
    return this.data.minuteAndStatus ?? this.data.match.statusObject.uiString;
  }

  public clearMatch() {
    this.data = null;
  }

  public hasAnyVideos(): boolean {
    if (this.data.match && !this.data.match.videos) {
      return false;
    }

    const hasMainVideos =
      this.data.match.videos.highlightsURL ||
      this.data.match.videos.livestreamURL;

    const hasActivityVideo = this.data.entries.some((entry) => {
      return (
        entry instanceof Activity &&
        entry.video?.preview_url &&
        entry.video?.video_url
      );
    });

    return !!hasMainVideos || hasActivityVideo;
  }

  public getActivitiesWithVideos(): Activity[] {
    return this.data.entries.filter(value => {
      if (value instanceof Activity) {
        return this.activityHasVideos(value);
      }
      return false;
    }) as Activity[];
  }

  private activityHasVideos(activity: Activity): boolean {
    const hasVideo = activity.video?.video_url !== undefined;
    const hasNativeVideo = activity.videos_native && activity.videos_native.length > 0;
    return hasVideo || hasNativeVideo;
  }

  public showLineUpTab(): boolean {
    if (
      (this.data &&
        this.data.match &&
        this.data.match.isAtLeastOneHourBeforeMatchStart()) ||
      this.data.match.isCurrentOrPast()
    ) {
      if (this.data.homeLineup && this.data.awayLineup) {
        if (
          this.data.homeLineup.hasNoFormationButPlayers() ||
          this.data.awayLineup.hasNoFormationButPlayers() ||
          this.data.homeLineup.hasFormation() ||
          this.data.awayLineup.hasFormation()
        ) {
          return true;
        }
      }
    }
    return false;
  }

  private async getTabsToDisplay() {
    const matchId = this.data.match.id;
    const route = this.apiService.getBaseURL() + `v2/events/${matchId}/tabs/`;
    const response = await this.http.get(route, this.apiService.getJsonOptions()).toPromise();
    if (response) {
      return this.resolveTabsToDisplay(response);
    }
  }

  private resolveTabsToDisplay(json: any) {
    const lineup = json.data.lineup.home || json.data.lineup.away;
    const liveticker = json.data.liveticker.home || json.data.liveticker.away;
    const overview = json.data.overview.home || json.data.overview.away;
    const table = json.data.table.home || json.data.table.away;
    const timeline = json.data.timeline.home || json.data.timeline.away;
    const videos = json.data.videos.home || json.data.videos.away;

    return { lineup, liveticker, overview, table, timeline, videos };
  }

  private async reloadMatch(): Promise<void> {
    this.data.match = await this.matchService.fetchMatch(this.data.match.id);
  }

  private async loadTimeline(matchId: string, teamId: string): Promise<void> {
    try {
      const response = await this.matchService.fetchMatchTimeline(
        matchId,
        teamId
      );
      this.data.entries = [];
      this.filterEntries(response);
    } catch (e) {
      console.error("[Match] Could not load timeline!", matchId, teamId);
      throw e;
    }
  }

  private async loadTeamLineups(match: Match): Promise<void> {
    try {
      this.matchService
        .fetchMatchLineup(match.id, match.teams.home.teamid)
        .then((response) => {
          this.data.homeLineup = response;
        });
      this.matchService
        .fetchMatchLineup(match.id, match.teams.away.teamid)
        .then((response) => {
          this.data.awayLineup = response;
        });
    } catch (e) {
      console.error("[Match] Could not load lineups for match!");
      throw e;
    }
  }
}
